import {
  useOnActiveEngagementChangedSubscription,
  useOnEngagementChangedSubscription,
  useGetEventQuery,
  useGetEventLazyQuery,
} from '@/generated/graphql';
import { createLogger } from '@/utils/createLogger';

const logger = createLogger('useAdminEvent');

export function useAdminEvent({ id }: { id: string }) {
  const { data, loading, error } = useGetEventQuery({
    fetchPolicy: 'network-only',
    variables: {
      id,
    },
    onError: (error) => {
      logger.error('Error fetching event', error);
    },
    onCompleted: () => {
      logger.debug('Event fetched');
    },
  });

  const [getEventLazy] = useGetEventLazyQuery();

  // this will update the cache with the new active engagement
  useOnActiveEngagementChangedSubscription({
    variables: { eventId: id },
    onData: () => {
      getEventLazy({
        variables: {
          id,
        },
      });
    },
  });

  const event = data?.event;
  const engagement = event?.activeEngagement;

  const skip = !event || !engagement || !engagement.id;
  logger.info(`calling useOnEngagementChangedSubscription. skip: ${skip}`);
  useOnEngagementChangedSubscription({
    skip,
    variables: {
      engagementId: engagement?.id || '',
    },
    onData: ({ data }) => {
      logger.debug('Active engagement modified, updating cache', data);
      const changes = data?.data?.engagementChanged;
      if (changes) {
        // Update the Apollo cache with any changed fields
        getEventLazy({
          variables: {
            id,
          },
        });
      }
    },
  });

  return {
    data,
    loading,
    error,
  };
}
